import React from "react";

const NotFound = () => {
  return <h1>Whoops! You're in the wrong place, bud.</h1>;
};

export default NotFound;
